/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddDocumentToPalAuthSubmission201Response,
  AddDocumentToPalAuthSubmissionRequest,
  AuthPlatformRemotePatientSearchPayload,
  CreatePalSubmissionRequest,
  CreatePayerContracts201Response,
  EnabledPayer,
  FindAllPalAuthIntegrationsForLead200Response,
  FindAllPalSubmissions200Response,
  FindOnePalInfo200Response,
  GenerateEligibilityCheckReport200Response,
  GetEligibilityChecks200Response,
  GetEnabledPayers200Response,
  GetExaCarePayerList200Response,
  GetInovalonPayerList200Response,
  GetInovalonPayerSearchOptions200Response,
  GetLatestPalSubmission200Response,
  GetLeadAssessmentForm200Response,
  GetMedicareAssessmentFormOptions200Response,
  GetMedicareEstimates200Response,
  GetMedicarePtOtMappings200Response,
  GetPayerContractRules200Response,
  GetPayerContracts200Response,
  GetTimExecution200Response,
  MarkPalAuthSubmissionAsManualRequest,
  MarkPayerAsInnRequest,
  MedicareAssessmentForm,
  PayerContract,
  PayerContractUpdate,
  PerformEligibilityCheck200Response,
  PerformEligibilityCheck400Response,
  PerformEligibilityCheckRequest,
  ReviewPalAuthSubmissionRequest,
  ScreenerInsurance,
  SearchPalAuthPlatformRemotePatient200Response,
  SubmitPalAuthSubmissionRequest,
  UpdateEnabledPayersBulkRequest,
  UpdateLeadInsurances200Response,
  UpdatePalAuthSubmissionRequest,
} from '../models/index';
import {
    AddDocumentToPalAuthSubmission201ResponseFromJSON,
    AddDocumentToPalAuthSubmission201ResponseToJSON,
    AddDocumentToPalAuthSubmissionRequestFromJSON,
    AddDocumentToPalAuthSubmissionRequestToJSON,
    AuthPlatformRemotePatientSearchPayloadFromJSON,
    AuthPlatformRemotePatientSearchPayloadToJSON,
    CreatePalSubmissionRequestFromJSON,
    CreatePalSubmissionRequestToJSON,
    CreatePayerContracts201ResponseFromJSON,
    CreatePayerContracts201ResponseToJSON,
    EnabledPayerFromJSON,
    EnabledPayerToJSON,
    FindAllPalAuthIntegrationsForLead200ResponseFromJSON,
    FindAllPalAuthIntegrationsForLead200ResponseToJSON,
    FindAllPalSubmissions200ResponseFromJSON,
    FindAllPalSubmissions200ResponseToJSON,
    FindOnePalInfo200ResponseFromJSON,
    FindOnePalInfo200ResponseToJSON,
    GenerateEligibilityCheckReport200ResponseFromJSON,
    GenerateEligibilityCheckReport200ResponseToJSON,
    GetEligibilityChecks200ResponseFromJSON,
    GetEligibilityChecks200ResponseToJSON,
    GetEnabledPayers200ResponseFromJSON,
    GetEnabledPayers200ResponseToJSON,
    GetExaCarePayerList200ResponseFromJSON,
    GetExaCarePayerList200ResponseToJSON,
    GetInovalonPayerList200ResponseFromJSON,
    GetInovalonPayerList200ResponseToJSON,
    GetInovalonPayerSearchOptions200ResponseFromJSON,
    GetInovalonPayerSearchOptions200ResponseToJSON,
    GetLatestPalSubmission200ResponseFromJSON,
    GetLatestPalSubmission200ResponseToJSON,
    GetLeadAssessmentForm200ResponseFromJSON,
    GetLeadAssessmentForm200ResponseToJSON,
    GetMedicareAssessmentFormOptions200ResponseFromJSON,
    GetMedicareAssessmentFormOptions200ResponseToJSON,
    GetMedicareEstimates200ResponseFromJSON,
    GetMedicareEstimates200ResponseToJSON,
    GetMedicarePtOtMappings200ResponseFromJSON,
    GetMedicarePtOtMappings200ResponseToJSON,
    GetPayerContractRules200ResponseFromJSON,
    GetPayerContractRules200ResponseToJSON,
    GetPayerContracts200ResponseFromJSON,
    GetPayerContracts200ResponseToJSON,
    GetTimExecution200ResponseFromJSON,
    GetTimExecution200ResponseToJSON,
    MarkPalAuthSubmissionAsManualRequestFromJSON,
    MarkPalAuthSubmissionAsManualRequestToJSON,
    MarkPayerAsInnRequestFromJSON,
    MarkPayerAsInnRequestToJSON,
    MedicareAssessmentFormFromJSON,
    MedicareAssessmentFormToJSON,
    PayerContractFromJSON,
    PayerContractToJSON,
    PayerContractUpdateFromJSON,
    PayerContractUpdateToJSON,
    PerformEligibilityCheck200ResponseFromJSON,
    PerformEligibilityCheck200ResponseToJSON,
    PerformEligibilityCheck400ResponseFromJSON,
    PerformEligibilityCheck400ResponseToJSON,
    PerformEligibilityCheckRequestFromJSON,
    PerformEligibilityCheckRequestToJSON,
    ReviewPalAuthSubmissionRequestFromJSON,
    ReviewPalAuthSubmissionRequestToJSON,
    ScreenerInsuranceFromJSON,
    ScreenerInsuranceToJSON,
    SearchPalAuthPlatformRemotePatient200ResponseFromJSON,
    SearchPalAuthPlatformRemotePatient200ResponseToJSON,
    SubmitPalAuthSubmissionRequestFromJSON,
    SubmitPalAuthSubmissionRequestToJSON,
    UpdateEnabledPayersBulkRequestFromJSON,
    UpdateEnabledPayersBulkRequestToJSON,
    UpdateLeadInsurances200ResponseFromJSON,
    UpdateLeadInsurances200ResponseToJSON,
    UpdatePalAuthSubmissionRequestFromJSON,
    UpdatePalAuthSubmissionRequestToJSON,
} from '../models/index';

export interface AddDocumentToPalAuthSubmissionOperationRequest {
    palAuthSubmissionId: string;
    addDocumentToPalAuthSubmissionRequest: AddDocumentToPalAuthSubmissionRequest;
}

export interface CreatePalSubmissionOperationRequest {
    leadId: string;
    createPalSubmissionRequest: CreatePalSubmissionRequest;
}

export interface CreatePayerContractsRequest {
    payerContract: PayerContract;
}

export interface CreateTimExecutionRequest {
    leadId: string;
}

export interface DeleteDocumentFromPalAuthSubmissionRequest {
    palAuthSubmissionId: string;
    documentId: string;
}

export interface DeleteEligibilityCheckByIdRequest {
    leadId: string;
    checkId: string;
}

export interface DeleteEnabledPayerRequest {
    payerId: string;
}

export interface DeletePayerContractByIdRequest {
    payerContractId: string;
}

export interface EnablePayerRequest {
    enabledPayer: EnabledPayer;
}

export interface FindAllPalAuthIntegrationsForLeadRequest {
    leadId: string;
}

export interface FindAllPalSubmissionsRequest {
    facilityId?: string;
    submissionStatus?: string;
    admissionStatus?: string;
    search?: string;
    limit?: number;
    page?: number;
    sortBy?: FindAllPalSubmissionsSortByEnum;
    sortOrder?: FindAllPalSubmissionsSortOrderEnum;
    includeEmptyAdmission?: boolean;
}

export interface FindOnePalInfoRequest {
    leadId: string;
}

export interface GenerateEligibilityCheckReportRequest {
    leadId: string;
    checkId: string;
}

export interface GetEligibilityCheckByIdRequest {
    leadId: string;
    checkId: string;
}

export interface GetEligibilityChecksRequest {
    leadId: string;
}

export interface GetInovalonPayerSearchOptionsRequest {
    payerId: string;
}

export interface GetLatestPalSubmissionRequest {
    leadId: string;
}

export interface GetLeadAssessmentFormRequest {
    leadId: string;
}

export interface GetMedicareEstimatesRequest {
    leadId: string;
}

export interface GetPayerContractByIdRequest {
    payerContractId: string;
}

export interface GetPayerContractRulesRequest {
    payerContractId: any;
}

export interface GetTimExecutionRequest {
    leadId: string;
}

export interface MarkPalAuthSubmissionAsManualOperationRequest {
    palAuthSubmissionId: string;
    markPalAuthSubmissionAsManualRequest?: MarkPalAuthSubmissionAsManualRequest;
}

export interface MarkPayerAsInnOperationRequest {
    payerId: string;
    markPayerAsInnRequest: MarkPayerAsInnRequest;
}

export interface PerformEligibilityCheckOperationRequest {
    leadId: string;
    performEligibilityCheckRequest: PerformEligibilityCheckRequest;
}

export interface RefreshPalAuthSubmissionLevelAssessmentRequest {
    palAuthSubmissionId: string;
}

export interface RestartPalSubmissionRequest {
    palAuthSubmissionId: string;
}

export interface RevertPalAuthSubmissionStatusRequest {
    palAuthSubmissionId: string;
}

export interface ReviewPalAuthSubmissionOperationRequest {
    palAuthSubmissionId: string;
    reviewPalAuthSubmissionRequest?: ReviewPalAuthSubmissionRequest;
}

export interface SearchPalAuthPlatformRemotePatientRequest {
    palAuthSubmissionId: string;
    authPlatformRemotePatientSearchPayload: AuthPlatformRemotePatientSearchPayload;
}

export interface SubmitPalAuthSubmissionOperationRequest {
    palAuthSubmissionId: string;
    submitPalAuthSubmissionRequest: SubmitPalAuthSubmissionRequest;
}

export interface UnmarkPayerAsInnRequest {
    payerId: string;
    facilityId: string;
}

export interface UpdateEnabledPayersBulkOperationRequest {
    updateEnabledPayersBulkRequest: UpdateEnabledPayersBulkRequest;
}

export interface UpdateLeadAssessmentFormRequest {
    leadId: string;
    medicareAssessmentForm: MedicareAssessmentForm;
}

export interface UpdateLeadInsurancesRequest {
    leadId: string;
    screenerInsurance: Array<ScreenerInsurance>;
}

export interface UpdatePalAuthSubmissionOperationRequest {
    palAuthSubmissionId: string;
    updatePalAuthSubmissionRequest: UpdatePalAuthSubmissionRequest;
}

export interface UpdatePayerContractByIdRequest {
    payerContractId: string;
    payerContractUpdate: PayerContractUpdate;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Add documents to submit to a PAL auth submission
     */
    async addDocumentToPalAuthSubmissionRaw(requestParameters: AddDocumentToPalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddDocumentToPalAuthSubmission201Response>> {
        if (requestParameters.palAuthSubmissionId === null || requestParameters.palAuthSubmissionId === undefined) {
            throw new runtime.RequiredError('palAuthSubmissionId','Required parameter requestParameters.palAuthSubmissionId was null or undefined when calling addDocumentToPalAuthSubmission.');
        }

        if (requestParameters.addDocumentToPalAuthSubmissionRequest === null || requestParameters.addDocumentToPalAuthSubmissionRequest === undefined) {
            throw new runtime.RequiredError('addDocumentToPalAuthSubmissionRequest','Required parameter requestParameters.addDocumentToPalAuthSubmissionRequest was null or undefined when calling addDocumentToPalAuthSubmission.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/pal-auth-submissions/{pal_auth_submission_id}/documents-to-submit`.replace(`{${"pal_auth_submission_id"}}`, encodeURIComponent(String(requestParameters.palAuthSubmissionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddDocumentToPalAuthSubmissionRequestToJSON(requestParameters.addDocumentToPalAuthSubmissionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddDocumentToPalAuthSubmission201ResponseFromJSON(jsonValue));
    }

    /**
     * Add documents to submit to a PAL auth submission
     */
    async addDocumentToPalAuthSubmission(requestParameters: AddDocumentToPalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddDocumentToPalAuthSubmission201Response> {
        const response = await this.addDocumentToPalAuthSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create PAL submission for a lead
     */
    async createPalSubmissionRaw(requestParameters: CreatePalSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling createPalSubmission.');
        }

        if (requestParameters.createPalSubmissionRequest === null || requestParameters.createPalSubmissionRequest === undefined) {
            throw new runtime.RequiredError('createPalSubmissionRequest','Required parameter requestParameters.createPalSubmissionRequest was null or undefined when calling createPalSubmission.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/screener-leads/{lead_id}/pal-submission`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePalSubmissionRequestToJSON(requestParameters.createPalSubmissionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Create PAL submission for a lead
     */
    async createPalSubmission(requestParameters: CreatePalSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.createPalSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create payer contract for a facility
     */
    async createPayerContractsRaw(requestParameters: CreatePayerContractsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePayerContracts201Response>> {
        if (requestParameters.payerContract === null || requestParameters.payerContract === undefined) {
            throw new runtime.RequiredError('payerContract','Required parameter requestParameters.payerContract was null or undefined when calling createPayerContracts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/payer-contracts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PayerContractToJSON(requestParameters.payerContract),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePayerContracts201ResponseFromJSON(jsonValue));
    }

    /**
     * Create payer contract for a facility
     */
    async createPayerContracts(requestParameters: CreatePayerContractsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePayerContracts201Response> {
        const response = await this.createPayerContractsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create TIM execution for a lead
     */
    async createTimExecutionRaw(requestParameters: CreateTimExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTimExecution200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling createTimExecution.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-leads/{lead_id}/tim/execution`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTimExecution200ResponseFromJSON(jsonValue));
    }

    /**
     * Create TIM execution for a lead
     */
    async createTimExecution(requestParameters: CreateTimExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTimExecution200Response> {
        const response = await this.createTimExecutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a document from the list of documents to submit to a PAL auth submission
     */
    async deleteDocumentFromPalAuthSubmissionRaw(requestParameters: DeleteDocumentFromPalAuthSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.palAuthSubmissionId === null || requestParameters.palAuthSubmissionId === undefined) {
            throw new runtime.RequiredError('palAuthSubmissionId','Required parameter requestParameters.palAuthSubmissionId was null or undefined when calling deleteDocumentFromPalAuthSubmission.');
        }

        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling deleteDocumentFromPalAuthSubmission.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/pal-auth-submissions/{pal_auth_submission_id}/documents-to-submit/{document_id}`.replace(`{${"pal_auth_submission_id"}}`, encodeURIComponent(String(requestParameters.palAuthSubmissionId))).replace(`{${"document_id"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a document from the list of documents to submit to a PAL auth submission
     */
    async deleteDocumentFromPalAuthSubmission(requestParameters: DeleteDocumentFromPalAuthSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDocumentFromPalAuthSubmissionRaw(requestParameters, initOverrides);
    }

    /**
     * Delete eligibility check by ID
     */
    async deleteEligibilityCheckByIdRaw(requestParameters: DeleteEligibilityCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling deleteEligibilityCheckById.');
        }

        if (requestParameters.checkId === null || requestParameters.checkId === undefined) {
            throw new runtime.RequiredError('checkId','Required parameter requestParameters.checkId was null or undefined when calling deleteEligibilityCheckById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-leads/{lead_id}/eligibility-checks/{check_id}`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))).replace(`{${"check_id"}}`, encodeURIComponent(String(requestParameters.checkId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete eligibility check by ID
     */
    async deleteEligibilityCheckById(requestParameters: DeleteEligibilityCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEligibilityCheckByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Delete enabled payer
     */
    async deleteEnabledPayerRaw(requestParameters: DeleteEnabledPayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.payerId === null || requestParameters.payerId === undefined) {
            throw new runtime.RequiredError('payerId','Required parameter requestParameters.payerId was null or undefined when calling deleteEnabledPayer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/enabled-payers/{payer_id}`.replace(`{${"payer_id"}}`, encodeURIComponent(String(requestParameters.payerId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete enabled payer
     */
    async deleteEnabledPayer(requestParameters: DeleteEnabledPayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEnabledPayerRaw(requestParameters, initOverrides);
    }

    /**
     * Delete payer contract by id
     */
    async deletePayerContractByIdRaw(requestParameters: DeletePayerContractByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.payerContractId === null || requestParameters.payerContractId === undefined) {
            throw new runtime.RequiredError('payerContractId','Required parameter requestParameters.payerContractId was null or undefined when calling deletePayerContractById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payer-contracts/{payer_contract_id}`.replace(`{${"payer_contract_id"}}`, encodeURIComponent(String(requestParameters.payerContractId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete payer contract by id
     */
    async deletePayerContractById(requestParameters: DeletePayerContractByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePayerContractByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Enable a payer for the current organization
     */
    async enablePayerRaw(requestParameters: EnablePayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.enabledPayer === null || requestParameters.enabledPayer === undefined) {
            throw new runtime.RequiredError('enabledPayer','Required parameter requestParameters.enabledPayer was null or undefined when calling enablePayer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/enabled-payers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EnabledPayerToJSON(requestParameters.enabledPayer),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Enable a payer for the current organization
     */
    async enablePayer(requestParameters: EnablePayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.enablePayerRaw(requestParameters, initOverrides);
    }

    /**
     * Find all PAL auth integrations enabled for a lead
     */
    async findAllPalAuthIntegrationsForLeadRaw(requestParameters: FindAllPalAuthIntegrationsForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllPalAuthIntegrationsForLead200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling findAllPalAuthIntegrationsForLead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-leads/{lead_id}/pal-authorizations/integrations`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllPalAuthIntegrationsForLead200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all PAL auth integrations enabled for a lead
     */
    async findAllPalAuthIntegrationsForLead(requestParameters: FindAllPalAuthIntegrationsForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllPalAuthIntegrationsForLead200Response> {
        const response = await this.findAllPalAuthIntegrationsForLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all PAL submissions with pagination
     */
    async findAllPalSubmissionsRaw(requestParameters: FindAllPalSubmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllPalSubmissions200Response>> {
        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        if (requestParameters.submissionStatus !== undefined) {
            queryParameters['submission_status'] = requestParameters.submissionStatus;
        }

        if (requestParameters.admissionStatus !== undefined) {
            queryParameters['admission_status'] = requestParameters.admissionStatus;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.sortOrder !== undefined) {
            queryParameters['sort_order'] = requestParameters.sortOrder;
        }

        if (requestParameters.includeEmptyAdmission !== undefined) {
            queryParameters['include_empty_admission'] = requestParameters.includeEmptyAdmission;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/pal-submissions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllPalSubmissions200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all PAL submissions with pagination
     */
    async findAllPalSubmissions(requestParameters: FindAllPalSubmissionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllPalSubmissions200Response> {
        const response = await this.findAllPalSubmissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find PAL information for a lead
     */
    async findOnePalInfoRaw(requestParameters: FindOnePalInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOnePalInfo200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling findOnePalInfo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-leads/{lead_id}/pal-info`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOnePalInfo200ResponseFromJSON(jsonValue));
    }

    /**
     * Find PAL information for a lead
     */
    async findOnePalInfo(requestParameters: FindOnePalInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOnePalInfo200Response> {
        const response = await this.findOnePalInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate eligibility check report for a lead
     */
    async generateEligibilityCheckReportRaw(requestParameters: GenerateEligibilityCheckReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateEligibilityCheckReport200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling generateEligibilityCheckReport.');
        }

        if (requestParameters.checkId === null || requestParameters.checkId === undefined) {
            throw new runtime.RequiredError('checkId','Required parameter requestParameters.checkId was null or undefined when calling generateEligibilityCheckReport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-leads/{lead_id}/eligibility-checks/{check_id}/report`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))).replace(`{${"check_id"}}`, encodeURIComponent(String(requestParameters.checkId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateEligibilityCheckReport200ResponseFromJSON(jsonValue));
    }

    /**
     * Generate eligibility check report for a lead
     */
    async generateEligibilityCheckReport(requestParameters: GenerateEligibilityCheckReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateEligibilityCheckReport200Response> {
        const response = await this.generateEligibilityCheckReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get eligibility check by ID
     */
    async getEligibilityCheckByIdRaw(requestParameters: GetEligibilityCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PerformEligibilityCheck200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling getEligibilityCheckById.');
        }

        if (requestParameters.checkId === null || requestParameters.checkId === undefined) {
            throw new runtime.RequiredError('checkId','Required parameter requestParameters.checkId was null or undefined when calling getEligibilityCheckById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-leads/{lead_id}/eligibility-checks/{check_id}`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))).replace(`{${"check_id"}}`, encodeURIComponent(String(requestParameters.checkId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PerformEligibilityCheck200ResponseFromJSON(jsonValue));
    }

    /**
     * Get eligibility check by ID
     */
    async getEligibilityCheckById(requestParameters: GetEligibilityCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PerformEligibilityCheck200Response> {
        const response = await this.getEligibilityCheckByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get eligibility checks for a lead
     */
    async getEligibilityChecksRaw(requestParameters: GetEligibilityChecksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEligibilityChecks200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling getEligibilityChecks.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-leads/{lead_id}/eligibility-checks`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEligibilityChecks200ResponseFromJSON(jsonValue));
    }

    /**
     * Get eligibility checks for a lead
     */
    async getEligibilityChecks(requestParameters: GetEligibilityChecksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEligibilityChecks200Response> {
        const response = await this.getEligibilityChecksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get payers enabled for the current organization
     */
    async getEnabledPayersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEnabledPayers200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/enabled-payers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEnabledPayers200ResponseFromJSON(jsonValue));
    }

    /**
     * Get payers enabled for the current organization
     */
    async getEnabledPayers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEnabledPayers200Response> {
        const response = await this.getEnabledPayersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get ExaCare payer list
     */
    async getExaCarePayerListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExaCarePayerList200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payers/exacare`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExaCarePayerList200ResponseFromJSON(jsonValue));
    }

    /**
     * Get ExaCare payer list
     */
    async getExaCarePayerList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExaCarePayerList200Response> {
        const response = await this.getExaCarePayerListRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all inovalon payers
     */
    async getInovalonPayerListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInovalonPayerList200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payers/inovalon`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInovalonPayerList200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all inovalon payers
     */
    async getInovalonPayerList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInovalonPayerList200Response> {
        const response = await this.getInovalonPayerListRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get payer search options for a payer
     */
    async getInovalonPayerSearchOptionsRaw(requestParameters: GetInovalonPayerSearchOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInovalonPayerSearchOptions200Response>> {
        if (requestParameters.payerId === null || requestParameters.payerId === undefined) {
            throw new runtime.RequiredError('payerId','Required parameter requestParameters.payerId was null or undefined when calling getInovalonPayerSearchOptions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payers/inovalon/payer-search-options/{payer_id}`.replace(`{${"payer_id"}}`, encodeURIComponent(String(requestParameters.payerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInovalonPayerSearchOptions200ResponseFromJSON(jsonValue));
    }

    /**
     * Get payer search options for a payer
     */
    async getInovalonPayerSearchOptions(requestParameters: GetInovalonPayerSearchOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInovalonPayerSearchOptions200Response> {
        const response = await this.getInovalonPayerSearchOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get latest PAL submission for a lead
     */
    async getLatestPalSubmissionRaw(requestParameters: GetLatestPalSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling getLatestPalSubmission.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-leads/{lead_id}/pal-submission`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Get latest PAL submission for a lead
     */
    async getLatestPalSubmission(requestParameters: GetLatestPalSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.getLatestPalSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Medicare Assessment Form for a lead
     */
    async getLeadAssessmentFormRaw(requestParameters: GetLeadAssessmentFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeadAssessmentForm200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling getLeadAssessmentForm.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-leads/{lead_id}/medicare-estimates/assessment`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeadAssessmentForm200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Medicare Assessment Form for a lead
     */
    async getLeadAssessmentForm(requestParameters: GetLeadAssessmentFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeadAssessmentForm200Response> {
        const response = await this.getLeadAssessmentFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Medicare Assessment Form Options
     */
    async getMedicareAssessmentFormOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMedicareAssessmentFormOptions200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/medicare/assessment-form-options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMedicareAssessmentFormOptions200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Medicare Assessment Form Options
     */
    async getMedicareAssessmentFormOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMedicareAssessmentFormOptions200Response> {
        const response = await this.getMedicareAssessmentFormOptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get Medicare Reimbursment estimates for a lead
     */
    async getMedicareEstimatesRaw(requestParameters: GetMedicareEstimatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMedicareEstimates200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling getMedicareEstimates.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-leads/{lead_id}/medicare-estimates`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMedicareEstimates200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Medicare Reimbursment estimates for a lead
     */
    async getMedicareEstimates(requestParameters: GetMedicareEstimatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMedicareEstimates200Response> {
        const response = await this.getMedicareEstimatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Medicare PT/OT diagnoses/case-mix group mappings
     */
    async getMedicarePtOtMappingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMedicarePtOtMappings200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/medicare/pt-ot-mappings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMedicarePtOtMappings200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Medicare PT/OT diagnoses/case-mix group mappings
     */
    async getMedicarePtOtMappings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMedicarePtOtMappings200Response> {
        const response = await this.getMedicarePtOtMappingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get payer contract by id
     */
    async getPayerContractByIdRaw(requestParameters: GetPayerContractByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePayerContracts201Response>> {
        if (requestParameters.payerContractId === null || requestParameters.payerContractId === undefined) {
            throw new runtime.RequiredError('payerContractId','Required parameter requestParameters.payerContractId was null or undefined when calling getPayerContractById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payer-contracts/{payer_contract_id}`.replace(`{${"payer_contract_id"}}`, encodeURIComponent(String(requestParameters.payerContractId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePayerContracts201ResponseFromJSON(jsonValue));
    }

    /**
     * Get payer contract by id
     */
    async getPayerContractById(requestParameters: GetPayerContractByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePayerContracts201Response> {
        const response = await this.getPayerContractByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get rules for a payer contract
     */
    async getPayerContractRulesRaw(requestParameters: GetPayerContractRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPayerContractRules200Response>> {
        if (requestParameters.payerContractId === null || requestParameters.payerContractId === undefined) {
            throw new runtime.RequiredError('payerContractId','Required parameter requestParameters.payerContractId was null or undefined when calling getPayerContractRules.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payer-contracts/{payer_contract_id}/rules`.replace(`{${"payer_contract_id"}}`, encodeURIComponent(String(requestParameters.payerContractId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPayerContractRules200ResponseFromJSON(jsonValue));
    }

    /**
     * Get rules for a payer contract
     */
    async getPayerContractRules(requestParameters: GetPayerContractRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPayerContractRules200Response> {
        const response = await this.getPayerContractRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get payer contracts for all facilities available for the current user
     */
    async getPayerContractsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPayerContracts200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payer-contracts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPayerContracts200ResponseFromJSON(jsonValue));
    }

    /**
     * Get payer contracts for all facilities available for the current user
     */
    async getPayerContracts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPayerContracts200Response> {
        const response = await this.getPayerContractsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get TIM execution for a lead
     */
    async getTimExecutionRaw(requestParameters: GetTimExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTimExecution200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling getTimExecution.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-leads/{lead_id}/tim/execution`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTimExecution200ResponseFromJSON(jsonValue));
    }

    /**
     * Get TIM execution for a lead
     */
    async getTimExecution(requestParameters: GetTimExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTimExecution200Response> {
        const response = await this.getTimExecutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark a failed PAL auth submission as manually submitted
     */
    async markPalAuthSubmissionAsManualRaw(requestParameters: MarkPalAuthSubmissionAsManualOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        if (requestParameters.palAuthSubmissionId === null || requestParameters.palAuthSubmissionId === undefined) {
            throw new runtime.RequiredError('palAuthSubmissionId','Required parameter requestParameters.palAuthSubmissionId was null or undefined when calling markPalAuthSubmissionAsManual.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/pal-auth-submissions/{pal_auth_submission_id}/mark-manual-submission`.replace(`{${"pal_auth_submission_id"}}`, encodeURIComponent(String(requestParameters.palAuthSubmissionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarkPalAuthSubmissionAsManualRequestToJSON(requestParameters.markPalAuthSubmissionAsManualRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Mark a failed PAL auth submission as manually submitted
     */
    async markPalAuthSubmissionAsManual(requestParameters: MarkPalAuthSubmissionAsManualOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.markPalAuthSubmissionAsManualRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark payer as INN for a facility
     */
    async markPayerAsInnRaw(requestParameters: MarkPayerAsInnOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.payerId === null || requestParameters.payerId === undefined) {
            throw new runtime.RequiredError('payerId','Required parameter requestParameters.payerId was null or undefined when calling markPayerAsInn.');
        }

        if (requestParameters.markPayerAsInnRequest === null || requestParameters.markPayerAsInnRequest === undefined) {
            throw new runtime.RequiredError('markPayerAsInnRequest','Required parameter requestParameters.markPayerAsInnRequest was null or undefined when calling markPayerAsInn.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/enabled-payers/{payer_id}/inn-facilities`.replace(`{${"payer_id"}}`, encodeURIComponent(String(requestParameters.payerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarkPayerAsInnRequestToJSON(requestParameters.markPayerAsInnRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mark payer as INN for a facility
     */
    async markPayerAsInn(requestParameters: MarkPayerAsInnOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.markPayerAsInnRaw(requestParameters, initOverrides);
    }

    /**
     * Performs eligibility check for a lead
     */
    async performEligibilityCheckRaw(requestParameters: PerformEligibilityCheckOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PerformEligibilityCheck200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling performEligibilityCheck.');
        }

        if (requestParameters.performEligibilityCheckRequest === null || requestParameters.performEligibilityCheckRequest === undefined) {
            throw new runtime.RequiredError('performEligibilityCheckRequest','Required parameter requestParameters.performEligibilityCheckRequest was null or undefined when calling performEligibilityCheck.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/screener-leads/{lead_id}/eligibility-checks`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PerformEligibilityCheckRequestToJSON(requestParameters.performEligibilityCheckRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PerformEligibilityCheck200ResponseFromJSON(jsonValue));
    }

    /**
     * Performs eligibility check for a lead
     */
    async performEligibilityCheck(requestParameters: PerformEligibilityCheckOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PerformEligibilityCheck200Response> {
        const response = await this.performEligibilityCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Refresh level assessment for a submitted PAL auth submission
     */
    async refreshPalAuthSubmissionLevelAssessmentRaw(requestParameters: RefreshPalAuthSubmissionLevelAssessmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        if (requestParameters.palAuthSubmissionId === null || requestParameters.palAuthSubmissionId === undefined) {
            throw new runtime.RequiredError('palAuthSubmissionId','Required parameter requestParameters.palAuthSubmissionId was null or undefined when calling refreshPalAuthSubmissionLevelAssessment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/pal-auth-submissions/{pal_auth_submission_id}/refresh-level-assessment`.replace(`{${"pal_auth_submission_id"}}`, encodeURIComponent(String(requestParameters.palAuthSubmissionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Refresh level assessment for a submitted PAL auth submission
     */
    async refreshPalAuthSubmissionLevelAssessment(requestParameters: RefreshPalAuthSubmissionLevelAssessmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.refreshPalAuthSubmissionLevelAssessmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Restart a PAL auth submission from scratch
     */
    async restartPalSubmissionRaw(requestParameters: RestartPalSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        if (requestParameters.palAuthSubmissionId === null || requestParameters.palAuthSubmissionId === undefined) {
            throw new runtime.RequiredError('palAuthSubmissionId','Required parameter requestParameters.palAuthSubmissionId was null or undefined when calling restartPalSubmission.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/pal-auth-submissions/{pal_auth_submission_id}/restart`.replace(`{${"pal_auth_submission_id"}}`, encodeURIComponent(String(requestParameters.palAuthSubmissionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Restart a PAL auth submission from scratch
     */
    async restartPalSubmission(requestParameters: RestartPalSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.restartPalSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Revert PAL auth submission status to previous one
     */
    async revertPalAuthSubmissionStatusRaw(requestParameters: RevertPalAuthSubmissionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        if (requestParameters.palAuthSubmissionId === null || requestParameters.palAuthSubmissionId === undefined) {
            throw new runtime.RequiredError('palAuthSubmissionId','Required parameter requestParameters.palAuthSubmissionId was null or undefined when calling revertPalAuthSubmissionStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/pal-auth-submissions/{pal_auth_submission_id}/status-revert`.replace(`{${"pal_auth_submission_id"}}`, encodeURIComponent(String(requestParameters.palAuthSubmissionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Revert PAL auth submission status to previous one
     */
    async revertPalAuthSubmissionStatus(requestParameters: RevertPalAuthSubmissionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.revertPalAuthSubmissionStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Move PAL auth submission to review status
     */
    async reviewPalAuthSubmissionRaw(requestParameters: ReviewPalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        if (requestParameters.palAuthSubmissionId === null || requestParameters.palAuthSubmissionId === undefined) {
            throw new runtime.RequiredError('palAuthSubmissionId','Required parameter requestParameters.palAuthSubmissionId was null or undefined when calling reviewPalAuthSubmission.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/pal-auth-submissions/{pal_auth_submission_id}/review`.replace(`{${"pal_auth_submission_id"}}`, encodeURIComponent(String(requestParameters.palAuthSubmissionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReviewPalAuthSubmissionRequestToJSON(requestParameters.reviewPalAuthSubmissionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Move PAL auth submission to review status
     */
    async reviewPalAuthSubmission(requestParameters: ReviewPalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.reviewPalAuthSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search remote patient in the PAL auth platform
     */
    async searchPalAuthPlatformRemotePatientRaw(requestParameters: SearchPalAuthPlatformRemotePatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPalAuthPlatformRemotePatient200Response>> {
        if (requestParameters.palAuthSubmissionId === null || requestParameters.palAuthSubmissionId === undefined) {
            throw new runtime.RequiredError('palAuthSubmissionId','Required parameter requestParameters.palAuthSubmissionId was null or undefined when calling searchPalAuthPlatformRemotePatient.');
        }

        if (requestParameters.authPlatformRemotePatientSearchPayload === null || requestParameters.authPlatformRemotePatientSearchPayload === undefined) {
            throw new runtime.RequiredError('authPlatformRemotePatientSearchPayload','Required parameter requestParameters.authPlatformRemotePatientSearchPayload was null or undefined when calling searchPalAuthPlatformRemotePatient.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/pal-auth-submissions/{pal_auth_submission_id}/remote-patient-search`.replace(`{${"pal_auth_submission_id"}}`, encodeURIComponent(String(requestParameters.palAuthSubmissionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuthPlatformRemotePatientSearchPayloadToJSON(requestParameters.authPlatformRemotePatientSearchPayload),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchPalAuthPlatformRemotePatient200ResponseFromJSON(jsonValue));
    }

    /**
     * Search remote patient in the PAL auth platform
     */
    async searchPalAuthPlatformRemotePatient(requestParameters: SearchPalAuthPlatformRemotePatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPalAuthPlatformRemotePatient200Response> {
        const response = await this.searchPalAuthPlatformRemotePatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit a PAL auth submission
     */
    async submitPalAuthSubmissionRaw(requestParameters: SubmitPalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        if (requestParameters.palAuthSubmissionId === null || requestParameters.palAuthSubmissionId === undefined) {
            throw new runtime.RequiredError('palAuthSubmissionId','Required parameter requestParameters.palAuthSubmissionId was null or undefined when calling submitPalAuthSubmission.');
        }

        if (requestParameters.submitPalAuthSubmissionRequest === null || requestParameters.submitPalAuthSubmissionRequest === undefined) {
            throw new runtime.RequiredError('submitPalAuthSubmissionRequest','Required parameter requestParameters.submitPalAuthSubmissionRequest was null or undefined when calling submitPalAuthSubmission.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/pal-auth-submissions/{pal_auth_submission_id}/submit`.replace(`{${"pal_auth_submission_id"}}`, encodeURIComponent(String(requestParameters.palAuthSubmissionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitPalAuthSubmissionRequestToJSON(requestParameters.submitPalAuthSubmissionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Submit a PAL auth submission
     */
    async submitPalAuthSubmission(requestParameters: SubmitPalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.submitPalAuthSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unmark payer as INN for a facility
     */
    async unmarkPayerAsInnRaw(requestParameters: UnmarkPayerAsInnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.payerId === null || requestParameters.payerId === undefined) {
            throw new runtime.RequiredError('payerId','Required parameter requestParameters.payerId was null or undefined when calling unmarkPayerAsInn.');
        }

        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling unmarkPayerAsInn.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/enabled-payers/{payer_id}/inn-facilities/{facility_id}`.replace(`{${"payer_id"}}`, encodeURIComponent(String(requestParameters.payerId))).replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unmark payer as INN for a facility
     */
    async unmarkPayerAsInn(requestParameters: UnmarkPayerAsInnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unmarkPayerAsInnRaw(requestParameters, initOverrides);
    }

    /**
     * Enable or disable payers for the current organization
     */
    async updateEnabledPayersBulkRaw(requestParameters: UpdateEnabledPayersBulkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.updateEnabledPayersBulkRequest === null || requestParameters.updateEnabledPayersBulkRequest === undefined) {
            throw new runtime.RequiredError('updateEnabledPayersBulkRequest','Required parameter requestParameters.updateEnabledPayersBulkRequest was null or undefined when calling updateEnabledPayersBulk.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/enabled-payers/bulk`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateEnabledPayersBulkRequestToJSON(requestParameters.updateEnabledPayersBulkRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Enable or disable payers for the current organization
     */
    async updateEnabledPayersBulk(requestParameters: UpdateEnabledPayersBulkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateEnabledPayersBulkRaw(requestParameters, initOverrides);
    }

    /**
     * Update Medicare Assessment Form for a lead
     */
    async updateLeadAssessmentFormRaw(requestParameters: UpdateLeadAssessmentFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeadAssessmentForm200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling updateLeadAssessmentForm.');
        }

        if (requestParameters.medicareAssessmentForm === null || requestParameters.medicareAssessmentForm === undefined) {
            throw new runtime.RequiredError('medicareAssessmentForm','Required parameter requestParameters.medicareAssessmentForm was null or undefined when calling updateLeadAssessmentForm.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/screener-leads/{lead_id}/medicare-estimates/assessment`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MedicareAssessmentFormToJSON(requestParameters.medicareAssessmentForm),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeadAssessmentForm200ResponseFromJSON(jsonValue));
    }

    /**
     * Update Medicare Assessment Form for a lead
     */
    async updateLeadAssessmentForm(requestParameters: UpdateLeadAssessmentFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeadAssessmentForm200Response> {
        const response = await this.updateLeadAssessmentFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update insurances for a lead
     */
    async updateLeadInsurancesRaw(requestParameters: UpdateLeadInsurancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLeadInsurances200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling updateLeadInsurances.');
        }

        if (requestParameters.screenerInsurance === null || requestParameters.screenerInsurance === undefined) {
            throw new runtime.RequiredError('screenerInsurance','Required parameter requestParameters.screenerInsurance was null or undefined when calling updateLeadInsurances.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/screener-leads/{lead_id}/insurances`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.screenerInsurance.map(ScreenerInsuranceToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLeadInsurances200ResponseFromJSON(jsonValue));
    }

    /**
     * Update insurances for a lead
     */
    async updateLeadInsurances(requestParameters: UpdateLeadInsurancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLeadInsurances200Response> {
        const response = await this.updateLeadInsurancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a PAL auth submission
     */
    async updatePalAuthSubmissionRaw(requestParameters: UpdatePalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        if (requestParameters.palAuthSubmissionId === null || requestParameters.palAuthSubmissionId === undefined) {
            throw new runtime.RequiredError('palAuthSubmissionId','Required parameter requestParameters.palAuthSubmissionId was null or undefined when calling updatePalAuthSubmission.');
        }

        if (requestParameters.updatePalAuthSubmissionRequest === null || requestParameters.updatePalAuthSubmissionRequest === undefined) {
            throw new runtime.RequiredError('updatePalAuthSubmissionRequest','Required parameter requestParameters.updatePalAuthSubmissionRequest was null or undefined when calling updatePalAuthSubmission.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/pal-auth-submissions/{pal_auth_submission_id}`.replace(`{${"pal_auth_submission_id"}}`, encodeURIComponent(String(requestParameters.palAuthSubmissionId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePalAuthSubmissionRequestToJSON(requestParameters.updatePalAuthSubmissionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Update a PAL auth submission
     */
    async updatePalAuthSubmission(requestParameters: UpdatePalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.updatePalAuthSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update payer contract by id
     */
    async updatePayerContractByIdRaw(requestParameters: UpdatePayerContractByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.payerContractId === null || requestParameters.payerContractId === undefined) {
            throw new runtime.RequiredError('payerContractId','Required parameter requestParameters.payerContractId was null or undefined when calling updatePayerContractById.');
        }

        if (requestParameters.payerContractUpdate === null || requestParameters.payerContractUpdate === undefined) {
            throw new runtime.RequiredError('payerContractUpdate','Required parameter requestParameters.payerContractUpdate was null or undefined when calling updatePayerContractById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/payer-contracts/{payer_contract_id}`.replace(`{${"payer_contract_id"}}`, encodeURIComponent(String(requestParameters.payerContractId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PayerContractUpdateToJSON(requestParameters.payerContractUpdate),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update payer contract by id
     */
    async updatePayerContractById(requestParameters: UpdatePayerContractByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePayerContractByIdRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const FindAllPalSubmissionsSortByEnum = {
    StatusUpdatedAt: 'status_updated_at'
} as const;
export type FindAllPalSubmissionsSortByEnum = typeof FindAllPalSubmissionsSortByEnum[keyof typeof FindAllPalSubmissionsSortByEnum];
/**
 * @export
 */
export const FindAllPalSubmissionsSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type FindAllPalSubmissionsSortOrderEnum = typeof FindAllPalSubmissionsSortOrderEnum[keyof typeof FindAllPalSubmissionsSortOrderEnum];
